import actions from './actions'

const initialState = {
  loading: false,
  startLoading: false,
  statusLoading: false,
  deductionsLoading: false,
  cancelLoading: false,
  subscriptionStatus: {},
  subscriptionHistory: [],
  deductions: [],
}

export default function subscriptionReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
